import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { animationConfig } from '../sidenav.constants';
import SidenavIcon from '../customer/default/sidenavIcon/sidenavIcon.component';
import {
  colors,
  getInitialStyle,
  defaultContext,
  getStateStyles,
  ALPHA_ACTIVE,
  ALPHA_INACTIVE,
  getIndicatorPosition,
} from './sidenavItem.style';
import { SHOW_INDICATOR } from '../customer/default/sidenavItem.constants';

export default class SidenavItem extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          rect: true,
        },
        SidenavIcon: {
          type: SidenavIcon,
        },
        Indicator: {},
        Label: {},
      },
      getInitialStyle(),
    );
  }

  static _states() {
    return [
      class Unfocused extends this {
        $enter() {
          this.patch(getStateStyles(this._style).unfocused);
        }
      },
      class Focused extends this {
        $enter() {
          this.patch(getStateStyles(this._style).focused);
        }
      },
    ];
  }

  _construct() {
    this._style = defaultContext;
    this._isSelected = false;
    this._actionPath = '';
  }

  get item() {
    return this._item;
  }

  set item(value) {
    this._item = value;

    this.patch({
      Label: { text: { text: value.content.label } },
      SidenavIcon: {
        content: value.content,
      },
    });
  }

  get actionPath() {
    return this._actionPath;
  }

  set actionPath(value) {
    this._actionPath = value;
  }

  set expanded(value) {
    this.tag('Label').setSmooth('alpha', value ? 1 : 0, animationConfig);
    this.tag('Indicator').x = getIndicatorPosition(value, this._style.screenSize);
  }

  get colorMode() {
    return this._style.colorMode;
  }

  set colorMode(value) {
    this._style = { ...this._style, colorMode: value };
    this._updateColorMode();
  }

  set isSelected(value) {
    if (this._isSelected === value) {
      return;
    }
    this._isSelected = value;
    this._updateAlpha();
    this.tag('Indicator').alpha = SHOW_INDICATOR ? value : 0;
  }

  get isSelected() {
    return this._isSelected;
  }

  _updateColorMode() {
    this.patch({
      color: colors.background[this.colorMode],
    });

    this.$enter();
  }

  _updateAlpha() {
    this.alpha = this.isSelected ? ALPHA_ACTIVE : ALPHA_INACTIVE;
    this.tag('SidenavIcon').isSelected = this.isSelected;
  }

  _focus() {
    this._setState('Focused');
    this.alpha = ALPHA_ACTIVE;
  }

  _unfocus() {
    this._setState('Unfocused');
    this._updateAlpha();
  }
}
